import { render, staticRenderFns } from "./CardPointsList.vue?vue&type=template&id=0e1d6b57"
import script from "./CardPointsList.vue?vue&type=script&lang=js"
export * from "./CardPointsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports